import { observer } from 'mobx-react-lite'

import { DeleteAction } from './DeleteAction'

export const BulkActions = observer(() => {
  return <DeleteAction />
})
